import { TrackJS } from 'trackjs';

type ConsoleArgs = Parameters<typeof console.info>;
type ConsoleMethod = 'info' | 'error';

const emit = (method: ConsoleMethod, args: ConsoleArgs): void => {
  const safeArgs: unknown[] = args;

  if (TrackJS.isInstalled()) {
    TrackJS.console[method](...safeArgs);
    return;
  }

  console[method](...safeArgs);
};

export const log = {
  info: (...args: ConsoleArgs) => emit('info', args),
  error: (...args: ConsoleArgs) => emit('error', args),
};
